import { getAssistantActions, getUserActions } from "../../utils/taskActions";
import {
  Wrench,
  Archive,
  FolderInput,
  PlusCircle,
  ArrowRight,
  Reply,
  PencilOff,
  TicketPlusIcon,
  Forward,
  MailOpen
} from "lucide-react";

import { formatActionTypeLabel } from "../../utils/formatter";

export const EmailActionRibbon = ({ item, labels=undefined, readOnlyMode, onActionClick }) => {

  const getActionConfig = (action, item) => {
    const badgeCoreStyles = 'ml-0 font-semibold px-2 py-1 rounded-lg whitespace-nowrap';

    switch (action.type) {
      case 'archive':
        return {
          icon: (readOnlyMode && !item?.archived) ? <PencilOff size={24} className="text-stone-600 mt-1" /> : <Archive size={24} className="text-stone-600 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-stone-500 border-stone-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-stone-50 rounded-lg border border-stone-100 animate-fade-in'
        };
      case 'reply':
        return {
          icon: <Reply size={24} className="text-cyan-700 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-cyan-700 border-cyan-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-cyan-50 rounded-lg animate-fade-in'
        };
      case 'forward':
        return {
          icon: <Forward size={24} className="text-sky-700 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-sky-700 border-sky-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-sky-50 rounded-lg animate-fade-in'
        };
      case 'markRead':
        return {
          icon: <MailOpen size={24} className="text-teal-600 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-teal-600 border-teal-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-teal-50 rounded-lg animate-fade-in'
        };
      case 'move-to-label':
        return {
          icon: (readOnlyMode && !item?.archived) ? <PencilOff size={24} className="text-indigo-600 mt-1" /> : <ArrowRight size={24} className="text-indigo-600 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-indigo-600 border-indigo-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-indigo-50 rounded-lg animate-fade-in'
        };
      case 'create-a-task':
        return {
          icon: <PlusCircle size={24} className="text-emerald-600 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-emerald-600 border-emerald-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-emerald-50 rounded-lg animate-fade-in'
        };
      case 'create-a-maintenance-ticket':
        return {
          icon: <TicketPlusIcon size={24} className="text-emerald-600 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-emerald-600 border-emerald-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-emerald-50 rounded-lg animate-fade-in'
        };
      case 'add-to-project':
        return {
          icon: <FolderInput size={24} className="text-indigo-700 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-indigo-700 border-indigo-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-indigo-100 rounded-lg border border-indigo-100 animate-fade-in'
        };
      default:
        return {
          icon: <Wrench size={24} className="text-stone-500 mt-1" />,
          badge: <div className={`${badgeCoreStyles} text-white bg-stone-500 border-stone-100`}>{formatActionTypeLabel(action, labels)}</div>,
          styles: 'bg-stone-50 rounded-lg border border-stone-100 animate-fade-in'
        };
    }
  }

  return (
    <>
      {getAssistantActions(item?.actions)?.map((action, actionIndex) => (
        <div key={`assistant-action-${actionIndex}-${action.type}`} className={`w-full ${actionIndex === getAssistantActions(item?.actions).length - 1 ? '' : 'mb-1'}`}>
          <div 
            className={`flex flex-col justify-start items-start gap-2 p-2 w-full ${getActionConfig(action)?.styles} ${onActionClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`}
            onClick={onActionClick ? () => onActionClick(action) : undefined}
            data-amp-track-section="Digest Email Action"
            data-amp-track-action="Action_Click"
            data-amp-track-action_type={action.type}
          >
            <div className="flex flex-row items-center gap-2 w-full">
              {getActionConfig(action, item)?.icon}
              {getActionConfig(action)?.badge}
              {onActionClick && (
                <div className="ml-auto text-xs text-gray-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  Click for details
                </div>
              )}
            </div>
            <p className="text-gray-700 text-md leading-tight">{action.reason}</p>
          </div>
        </div>
      ))}
      {getUserActions(item?.actions)?.map((action, actionIndex) => (
        <div key={`parent-action-${actionIndex}-${action.type}`} className="flex flex-row items-center justify-start w-fit gap-2 py-2 px-2 border-stone-200 border bg-white rounded-md p-1 mt-1">
          <Wrench size={15} className="text-stone-500" />
          <p className="text-base text-gray-600 px-2">
            {action.reason}
          </p>
        </div>
      ))}    
    </>
  )
};

export default EmailActionRibbon;